import { render } from "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=template&id=607c7be0&scoped=true"
import script from "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=script&lang=js"
export * from "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=script&lang=js"

import "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=style&index=0&id=607c7be0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607c7be0"]])

export default __exports__